import React from "react";

const SvgHome = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.50297 4.60762L13.4205 8.13337V14.2525H11.8535V9.5515H7.15247V14.2525H5.58547V8.13337L9.50297 4.60762ZM9.50297 2.5L1.66797 9.5515H4.01847V15.8195H8.71947V11.1185H10.2865V15.8195H14.9875V9.5515H17.338"
      fill="#0C0324"
    />
  </svg>
);

export default SvgHome;
